// src/middleware/axios-security.ts
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-param-reassign */
import NodeRSA from 'node-rsa';
import type { InternalAxiosRequestConfig } from 'axios';
import { AxiosHeaders } from 'axios';
import { PUBLIC_KEY_HEADER, ENV } from '@/utils/api';

export type EnvMode = 'prod' | 'dev' | 'uat' | 'stg' | 'local' | string;

export type ExtAxiosConfig = InternalAxiosRequestConfig & {
  __encrypted?: boolean;
};

const RSA = new NodeRSA(PUBLIC_KEY_HEADER);
const ENV_MODE = ENV as unknown as EnvMode;

const SENSITIVE_KEY: string[] =
  ENV_MODE === 'prod'
    ? ['userId', 'role', 'subPassword', 'password', 'confirmPassword', 'newPassword', 'oldPassword']
    : ['role', 'subPassword', 'password', 'confirmPassword', 'newPassword', 'oldPassword'];

const hasUrlHost = (url?: string) => {
  if (!url) return false;
  return Boolean((url || '').split('/')[2]);
};

const ensureHeaders = (req: InternalAxiosRequestConfig) => {
  if (!(req.headers instanceof AxiosHeaders)) {
    req.headers = AxiosHeaders.from(req.headers || {});
  }
  return req.headers;
};

export const applySecurityRequest = (request: InternalAxiosRequestConfig) => {
  const req = request as ExtAxiosConfig;

  const headers = ensureHeaders(req);

  headers.set('x-secure-code', localStorage.getItem('x-secure-code') || '');
  headers.set('x-authorize', localStorage.getItem('x-authorize') || '');

  if (!req.__encrypted && (req as any).data && hasUrlHost(req.url as any)) {
    if ((req as any).data instanceof FormData) {
      return req;
    }

    const dataObj: any = (req as any).data;
    const keys = Object.keys(dataObj);

    for (let idx = 0; idx < keys.length; idx += 1) {
      const key = keys[idx];
      // eslint-disable-next-line no-continue
      if (!SENSITIVE_KEY.includes(key)) continue;

      const encrypted = RSA.encrypt(dataObj[key], 'base64');
      dataObj[key] = encrypted;

      if (key === 'subPassword') {
        localStorage.setItem('x-secure-code', encrypted);
        headers.set('x-secure-code', encrypted);
      }
    }

    (req as any).data = dataObj;
    req.__encrypted = true;
  }

  return req;
};
